// extracted by mini-css-extract-plugin
module.exports = {"base":"icon_base__cPzgS","inherit":"icon_inherit__u7nUA","container":"icon_container__UkQPv","badge":"icon_badge__p_dnt","labelContainer":"icon_labelContainer__IFeTa"};